import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  fetchRolodexData(
    { state },
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.getrolodexs}?PageSize=${pageSize}&PageNumber=${pageNumber}&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  // Create Rolodex
  createRolodex({ commit }, { rolodexData }) {
    // console.log(requestString)
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.createrolodex}`,
        rolodexData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error.response
      })
  },
  // Update Rolodex
  updateRolodex({ commit }, { rolodexData }) {
    // console.log(requestString)
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.updaterolodex}`,
        rolodexData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error.response
      })
  },
  // Delete Rolodex
  deleteRolodex({ commit }, { rolodexData }) {
    // console.log(requestString)
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.deleterolodexs}`,
        rolodexData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error.response
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
